const NUMERIC_INDEXATION = {
  One: '1%',
  Two: '2%',
  Three: '3%',
  Four: '4%',
  Five: '5%',
  Six: '6%',
  Seven: '7%',
  Eight: '8%',
  Nine: '9%',
  Ten: '10%',
  Eleven: '11%',
  Twelve: '12%',
  Thirteen: '13%',
  Fourteen: '14%',
  Fifteen: '15%',
};

export function formatTerm(meta) {
  if (!meta) return null;
  if (meta.startsWith('ToAge:')) {
    const age = meta.slice('ToAge:'.length);
    return `To age ${age}`;
  }
  return `${meta} yrs`;
}

export function formatCurrency(meta, options = {}) {
  if (!meta) return null;
  const n = Number(meta);
  if (!Number.isFinite(n) || n <= 0) return null;
  const formatted = `£${n.toLocaleString('en-GB', { maximumFractionDigits: 0 })}`;
  return options.monthly ? `${formatted}/mo` : formatted;
}

export function prettyIndexation(meta) {
  if (!meta) return null;
  return NUMERIC_INDEXATION[meta] ?? meta;
}

export function prettyDeferredPeriod(meta) {
  if (!meta) return null;
  // Inputs look like _0_Weeks, _3_Months, _12_Months, _24_Months
  const m = /^_(\d+)_(\w+)$/.exec(meta);
  if (!m) return meta;
  const n = m[1];
  const unit = m[2].toLowerCase();
  return `${n} ${unit}`;
}

export function prettyCoverBasis(meta) {
  if (!meta) return null;
  const v = meta.toLowerCase();
  if (v === 'level') return 'Level';
  if (v === 'decreasing') return 'Decreasing';
  if (v === 'increasing') return 'Increasing';
  return meta;
}
